import { render, staticRenderFns } from "./Detalhes.vue?vue&type=template&id=69103c75&scoped=true&lang=pug&"
import script from "./Detalhes.vue?vue&type=script&lang=js&"
export * from "./Detalhes.vue?vue&type=script&lang=js&"
import style0 from "./Detalhes.vue?vue&type=style&index=0&id=69103c75&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69103c75",
  null
  
)

export default component.exports